const initialState = {
    statusShow: false,
};
const menu = (state = initialState, action) => {
    switch (action.type) {
        case 'OPEN_MENU_LEFT':
            document.body.classList.add('modal-open');
            return {...state, statusShow: true};
        case 'CLOSE_MENU_LEFT':
            document.body.classList.remove('modal-open');
            return {...state, statusShow: false};
        default:
            return state;
    }
};

export default menu;